import * as pdfjsLib from "pdfjs-dist/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

/**
 * Render the first page of a PDF ArrayBuffer to a PNG blob URL.
 *
 * @param {ArrayBuffer} pdfBuffer - raw PDF bytes
 * @param {number} [scale=1] - render scale (1 = 72 dpi)
 * @returns {Promise<string>} blob URL of the rendered PNG image
 */
export async function pdfFirstPageToImageUrl(pdfBuffer, scale = 1) {
  const pdf = await pdfjsLib.getDocument({ data: pdfBuffer }).promise;
  const page = await pdf.getPage(1);
  const vp = page.getViewport({ scale });
  const canvas = document.createElement("canvas");
  canvas.width = vp.width;
  canvas.height = vp.height;
  const ctx = canvas.getContext("2d");
  await page.render({ canvasContext: ctx, viewport: vp }).promise;
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(URL.createObjectURL(blob));
      else reject(new Error("Canvas toBlob failed"));
    }, "image/png");
  });
}
